import { parseISO } from 'date-fns'

export const parseISOWithoutTimezone = (date: string): Date => {
  return parseISO(date.split('+')[0])
}
